import { ChevronDown, Factory, PackageCheck, Truck } from 'lucide-react';
import type { ReactNode } from 'react';

function Step({ icon, title, children }: { icon: ReactNode; title: string; children: ReactNode }) {
  return (
    <li className="flex gap-3">
      <span className="h-fit rounded-control bg-primary/10 p-2 text-primary">{icon}</span>
      <div>
        <p className="font-semibold">{title}</p>
        <p className="text-sm text-muted-foreground">{children}</p>
      </div>
    </li>
  );
}

/** Explains that the stock shown is real production, not a simulated counter. */
export function StockOrigin() {
  return (
    <details className="group mb-6 rounded-card border border-border bg-card p-4">
      <summary className="flex min-h-11 cursor-pointer list-none items-center justify-between gap-3 font-semibold">
        ¿De dónde sale este stock?
        <ChevronDown
          aria-hidden="true"
          className="size-5 text-muted-foreground transition-transform duration-200 group-open:rotate-180"
        />
      </summary>
      <ol className="mt-4 grid gap-4 md:grid-cols-3">
        <Step icon={<Truck aria-hidden="true" className="size-5" />} title="1. Compramos insumos">
          Principios activos, excipientes y envases a Farma Central, según lo que falta para
          producir.
        </Step>
        <Step icon={<Factory aria-hidden="true" className="size-5" />} title="2. Acondicionamos">
          Los insumos se transforman en blísters, frascos y viales, y estos se arman en kits. Cada
          paso queda registrado.
        </Step>
        <Step
          icon={<PackageCheck aria-hidden="true" className="size-5" />}
          title="3. Los vendemos aquí"
        >
          El número de disponibles es el stock real de nuestra bodega: baja con cada compra y con
          los vencimientos, y sube cuando terminamos de producir más kits.
        </Step>
      </ol>
    </details>
  );
}
